import * as React from "react";

interface DomElementHackProps {
    children: React.ReactNode;
}

export class DomElementHack extends React.Component<DomElementHackProps> {
    public render() {
        return <>{this.props.children}</>;
    }
}
